export const ORG_TYPE_OPTIONS = [
  { value: 'club', label: 'Club' },
  { value: 'league', label: 'Liga' },
  { value: 'academy', label: 'Academia' },
  { value: 'federation', label: 'Federacion' },
  { value: 'tournament_organizer', label: 'Organizador de torneos' },
];

export const ORG_TYPE_LABELS = Object.fromEntries(ORG_TYPE_OPTIONS.map(o => [o.value, o.label]));
